import { useState } from 'react';

import PublicHttpClient from '../../shared/infrastructures/clients/public-http.client';
import { extractApiErrorMessage } from '../../shared/utils/extract-api-error-message.util';
import { PUBLIC_AUTHENTICATION_API_PATHS } from '../constants/authentication-paths.constants';
import { ForgotPasswordRequestDTO } from '../types/authentication.dto';

const FALLBACK_MESSAGE = "L'envoi du lien a échoué";

type UseForgotPasswordResult = {
  isSubmitting: boolean;
  error: string | null;
  submit: (payload: ForgotPasswordRequestDTO) => Promise<boolean>;
};

export function useForgotPassword(): UseForgotPasswordResult {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (payload: ForgotPasswordRequestDTO): Promise<boolean> => {
    setIsSubmitting(true);
    setError(null);

    try {
      await PublicHttpClient.post<void, ForgotPasswordRequestDTO>(
        PUBLIC_AUTHENTICATION_API_PATHS.FORGOT_PASSWORD,
        payload
      );

      return true;
    } catch (caught) {
      setError(extractApiErrorMessage(caught, FALLBACK_MESSAGE));

      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { isSubmitting, error, submit };
}
